/* Recommended products in the cart page and cart drawer. See snippets/cart-recommendations.liquid.
   Cards are the theme's card-product (same as the collection page); adding to cart is the card's own quick add. */
if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.wrapper = this.querySelector('[data-recs-wrapper]');
      this.list = this.querySelector('[data-recs-list]');
      // The card's Quick buy opens a popup. Inside the drawer it would open underneath it, so close the drawer first;
      // adding to the cart in the popup reopens the drawer with the updated cart.
      this.addEventListener('click', (event) => {
        if (!event.target.closest('modal-opener')) return;
        const drawer = this.closest('cart-drawer');
        if (drawer && typeof drawer.close === 'function') drawer.close();
      });
      this.load();
    }

    /** Re-read the cart and reload the recommendations (used when the cart page updates in place). */
    async refresh() {
      try {
        const cart = await (await fetch(`${this.dataset.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })).json();
        const first = cart.items && cart.items[0];
        if (!first) {
          this.hidden = true;
          return;
        }
        this.dataset.productId = String(first.product_id);
        await this.load();
      } catch (error) {
        /* keep whatever is shown */
      }
    }

    async load() {
      const productId = this.dataset.productId;
      if (!productId) return;
      try {
        const root = this.dataset.root || '/';
        const url = `${root}recommendations/products?section_id=cart-recommendations&product_id=${encodeURIComponent(productId)}&limit=10&intent=related`;
        const response = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const items = doc.querySelector('[data-recs-list-source]');
        if (!items || !items.querySelector('[data-rec-item]')) {
          this.list.innerHTML = '';
          this.wrapper.hidden = true;
          this.hidden = true;
          return;
        }
        this.list.innerHTML = items.outerHTML;
        this.wrapper.hidden = false;
        this.hidden = false;
      } catch (error) {
        /* Recommendations are optional: fail silently and leave the cart untouched. */
      }
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
